import { isProduction } from '@/features/shared/utils/environment'
import { z } from 'zod'

// we allow @gmail.com for non-prod to allow testing
// without actual .edu accounts
export const studentEmailRegex = isProduction ? /\.edu$/ : /(\.edu|gmail.com|shipt.com)$/

export const studentEmailFormValidation = z
  .string()
  .email('Please enter a valid email address')
  .regex(studentEmailRegex, 'Please enter an .edu email address')

export const emailValidation = z
  .string()
  .min(1, 'Email is required')
  .email('Please enter a valid email address')

// matches isValidZip: 5 digit ZIP, optionally with a +4 extension
export const zipCodeSchema = z
  .string()
  .trim()
  .regex(/^\d{5}(-\d{4})?$/)

export const emailSchema = z.object({
  email: emailValidation,
})

export const studentEmailSchema = z.object({
  email: studentEmailFormValidation,
})
